module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ensanguining the skies")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("How heavily it dies")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Into the west away;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Past touch and sight and sound")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Not further to be found,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("How hopeless under ground")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Falls the remorseful day.")])]), _vm._v(" "), _c('p', {
    staticClass: "poemr"
  }, [_vm._v("A.E.Houseman")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("I")]), _vm._v("n "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beating the Nazi Invader,")]), _vm._v(" my first book to focus on Nazi spies and collaborators in Britain, I explored the years leading up to 1939 as the insidious tentacles of the Nazi party and its related security services spread to Britain. During the early war years when our country was under the cloud of invasion, Britain was first penetrated by Nazi spies who landed on our shores by rubber dinghy, fishing boats or were dropped onto fields inland by parachute.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this book I revisit those stories and complete the accounts of the known agents and sabotage parties who arrived by those means up to the later war years. I also relate some of the cases of those who evaded detection and were only revealed after their escape or their death while in this country. Bearing in mind the space offered by a single volume I draw, in the main, on the cases listed in the ‘Most Secret’ notes and appendices on the descent and landing of enemy agents compiled by MI5 during the war years now held in The National Archives (KV3/76).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main content of this book, however, focuses on the previously unpublished case histories of those named on the so-called ‘Black List’. This list comprised both ‘enemy aliens’ and British citizens from all strata of society who, at a time when there were genuine fears of a shadowy ‘Fifth Column’ of spies and collaborators existing in Britain, raised such concern to civil, military and security services that it was believed their loyalty could not be relied upon and they should not remain at large in the event of an invasion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("Spies and those acting ‘as agents of a foreign power’ (usually Germany) sent on sabotage missions and other nefarious acts had been a regular and highly popular feature of fact, pseudo-fact and fiction books, magazine features and newspaper stories over the decade of strained Anglo-German political and military relations before the outbreak of the First World War. Books such as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Riddle of the Sands")]), _vm._v(" (1903) where Erskine Childers weaves a tale of two young amateur sailors who uncover a sinister plot that looms over the international community. Other titles such as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Invasion of 1910")]), _vm._v(" (1906) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spies of the Kaiser")]), _vm._v(" (1909) both by William le Queux ably demonstrate the tenor of such literature which reached its zenith in the early years of the war with John Buchan’s classic Richard Hannay adventure "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Thirty-Nine Steps")]), _vm._v(" (1915).")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fx-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Parliament Square, London c1940 when coils of barbed wire and sentries had become common features near significant places for governance and the defence of Britain in wartime.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("Armed with such a canon of literature the dutiful citizens of Great Britain after the declaration of war in 1914 were wanting to ‘do their bit’. Fuelled with patriotism and no small measure of xenophobia, rumours and the sort of fear that can emerge in any population under the shadow of war, individuals and groups whose behaviour appeared suspicious were reported in their hundreds to police and military authorities. Particular concern was shown over those of German origin living in Britain; there was talk of Germans having deliberately integrated themselves into British society and were already spying or were waiting to rise up and commit acts of sabotage for the Kaiser.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Germans and Austrians still in Britain were rapidly labelled ‘Enemy Aliens’ and were sought out by military and police, arrested and interned, but not without rumours almost instantly emerging that those being taken away were in ‘fact’ German spies. Even after the internments the climate of fear was, at times, fanned by rumour and half truth until it bordered on spy hysteria or ‘spy mania’ and thousands of man hours of the police and military authorities’ time were expended on investigating the reports.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxi-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Thames House, on the corner of Horseferry Road adjacent to Lambeth Bridge and Millbank, Westminster, London c1935. Predominantly offices for Imperial Chemical Industries, between 1934 and August 1939 the top floor of the South Block provided offices for the staff of MI5.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("St James’s Street from Piccadilly, London c1939. After the MI5 offices at Wormwoods Scrubs were bombed the majority of staff removed to Blenheim Palace, but a London Office was maintained for the Director General and Guy Liddell, some of his counter-espionage officers and a small secretarial staff at 57–58 St. James’s Street.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxiii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("As the declaration of war between Britain and Germany became imminent during late August 1939 tourists and those who needed to flee Britain packed the boat trains for the continent that were leaving from all the major London stations.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the 1930s the theme of enemy spies, both overtly and thinly veiled operatives of the Nazis, was brought vividly to life on stage and on screen in both A and B movie thrillers. Among the biggest draws were Hitchcock’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Man Who Knew Too Much")]), _vm._v(" (1934), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Thirty Nine Steps")]), _vm._v(" (1935) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lady Vanishes")]), _vm._v(" (1938) not to mention Kurt Neumann’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Espionage")]), _vm._v(" (1937) based on Walter. C Hackett’s West End play of the same name. There was also Hollywood’s first explicitly anti-Nazi film "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Confessions of a Nazi Spy")]), _vm._v(" starring Edward G. Robinson, released in May 1939. The theme would continue throughout the Second World War in films such as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spare A Copper")]), _vm._v(" (1940) "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("starring George Formby, one of the most popular comedy entertainers of the day, Ealing Studios’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Foreman Went to France")]), _vm._v(" (1942) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Went the Day Well ")]), _vm._v(" (1942).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The difference was, although there were concerns over Nazi agents operating alone or in small cells in Britain the real fear in this new war was over a far wider spread, shadowy organisation which featured in the wartime films and was much bandied around in the popular press, fact and fictional stories in magazines and was the subject of conversations on the street or over the dining table. All members of this organisation were believed to have blind loyalty to the Nazi cause, they could be a neighbour, work colleague, local civic official, captain of industry or a stranger spotted lurking in the shadows. They could be utterly ruthless and use deadly force if required, determined to spy, commit acts of sabotage and ready to rise up and fight the British people from within in the event of an invasion. This group also had a name – The Fifth Column.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Neil R. Storey")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Norwich")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("2023")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc3d6254","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Intro.vue
// module id = 75
// module chunks = 0